import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateFundVarietyByFundCode(state, { id, data }) {
      // 变更状态
      Vue.set(state.fund, id, data);
    },
    updateCouponCard(state, { id, data }) {
      // 变更状态
      state.fund[`${id}CouponCard`] = data;
    },
  },
  actions: {
    updateFundVarietyByFundCode({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('CFHApi.getFundVarietyByFundCode', id)
          .then((json) => {
            commit('updateFundVarietyByFundCode', {
              id,
              data: json.data,
            });
            resolve(json.data);
          }).catch((error) => reject(error));
      });
    },
    updateCouponCard({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('CFHApi.getCouponCard', id)
          .then((json) => {
            commit('updateCouponCard', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {
    currentFundVarietyByFundInfo(state, getters, rootState) {
      return state.fund[rootState.native.fund.fundCode];
    },
  },
};
